<ap-accordion size="medium">
    <ap-accordion-item [accordionItemTitle]="signMessage()" [isEmpty]="isSignSummaryEmpty()" [borderDisabled]="isSignSummaryEmpty()">
        <dl>
            @for (keyTitle of signSummary(); track keyTitle) {
                <dt>{{ keyTitle.title }}</dt>
                <dd>{{ keyTitle.value }}</dd>
            }
        </dl>
    </ap-accordion-item>
</ap-accordion>
